export default __webpack_public_path__ + "static/media/Roboto-Black.1224b64c.ttf";